exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header{z-index:200}.header .header__back button{border:none;padding:5px;margin:-5px}", ""]);

// exports
